import React from "react"
import styled from "styled-components"
import BodyText from "./Typography/BodyText"

const TooltipContainer = styled.span`
  position: fixed;
  z-index: 999;
  border-radius: 6px;
  padding: 5px;
  visibility: hidden;
  transition:
    opacity 0.3s,
    visibility 0.1s;
  background-color: ${(props) => props.theme.palette.mediumDarkGray};
  color: ${(props) => props.theme.palette.white};
  opacity: 0;

  &.position-absolute {
    position: absolute;
  }

  &.medium {
    max-width: 520px;
  }

  &.align-right {
    right: 24px;
  }

  &.align-left {
    left: 80px;
  }

  &.position-top {
    position: absolute;
    top: -30px;
    right: 0;
  }
`
const HoverContainer = styled.div`
  position: relative;
  width: 100%;
  &:hover ${TooltipContainer} {
    opacity: 1;
    visibility: visible;
  }

  &.positon-unset {
    position: unset;
  }

  &.fit-content {
    width: fit-content;
  }
`

interface Props {
  text: string
  children?: React.ReactNode
  toolTipClassName?: string
  hoverClassName?: string
}

const Tooltip = (props: Props) => {
  const { children, text, toolTipClassName, hoverClassName } = props

  return (
    <HoverContainer className={hoverClassName}>
      {children}
      <TooltipContainer className={toolTipClassName}>
        <BodyText size="medium">{text}</BodyText>
      </TooltipContainer>
    </HoverContainer>
  )
}

export default Tooltip
